// Organizations shown in the landing hero collage (source: landingpagebackdrop/organizations.xlsx).
export const ORGANIZATIONS = [
  'AASHTO', 'ACI', 'AISC', 'AISI', 'ANSI', 'ASCE', 'ASME', 'ASTM', 'Atkore', 'AWC',
  'AWS', 'ClarkDietrich', 'HILTI', 'ICC', 'McNICHOLS', 'NAVFAC', 'NCEES', 'NCMA', 'NFPA', 'NIST',
  'OSHA', 'PCI', 'RCSC', 'RISA', 'SDI', 'SEI', 'SJI', 'SSMA', 'SST', 'TMS',
]
